<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">{{ `${salesOrder.code}` }} - {{ $t("COMMON.LOGS") }}</h3>
    <log-list-table :filterSubject="salesOrder" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "sales-order-view-logs",

  components: { LogListTable },

  props: ["salesOrder"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
